module.exports = __webpack_public_path__ + "img/conny-f-stage4.3237c3d4.png";